module.exports = __webpack_public_path__ + "img/Zac.727316c8.jpg";